import jQuery from "jquery";
window.$ = jQuery;
import "bootstrap";
import instantsearch from "instantsearch.js/es";
import {
  infiniteHits,
  configure,
  stats,
  refinementList,
  currentRefinements,
} from "instantsearch.js/es/widgets";

import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";

const anchorParams = new Proxy(
  new URLSearchParams(window.location.hash.replace("#", "")),
  {
    get: (anchorParams, prop) => anchorParams.get(prop),
  }
);

const TYPESENSE_SERVER_CONFIG = {
  apiKey: process.env.TYPESENSE_SEARCH_ONLY_API_KEY,
  nodes: [
    {
      host: anchorParams.host ? anchorParams.host : process.env.TYPESENSE_HOST,
      port: process.env.TYPESENSE_PORT,
      protocol: process.env.TYPESENSE_PROTOCOL,
      path: '/api/ts'
    },
  ],
  numRetries: 8,
  useServerSideSearchCache: false,
};

const INDEX_NAME = process.env.TYPESENSE_COLLECTION_NAME;

const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
  server: TYPESENSE_SERVER_CONFIG,
  additionalSearchParameters: {
    query_by: "vtext,emojis",
    facet_sample_threshold: 1000,
    facet_sample_percent: 20,
  },
});

const searchClient = typesenseInstantsearchAdapter.searchClient;

const search = instantsearch({
  searchClient,
  indexName: INDEX_NAME,
  future: {
    preserveSharedStateOnUnmount: true,
  },
});

// Emoji lookup map
const EMOJI_MAP = {
  "Abundance": "🌾", "Adoration": "😍", "Alms": "💵", "Anointing": "🧴",
  "Ascension": "⬆️", "Atonement": "🩸", "Beatitude": "🌺", "Benevolence": "🎗️",
  "Blessing": "🎁", "Bliss": "😌", "Charity": "🤲", "Comfort": "💚",
  "Commitment": "✊", "Communion": "🍷", "Compassion": "💕", "Consecration": "💫",
  "Contemplation": "💭", "Contentment": "☮️", "Contrition": "😞", "Courage": "⚔️",
  "Covenant": "📜", "Dedication": "🎖️", "Deliverance": "🗝️", "Destiny": "🧭",
  "Devotion": "📿", "Discernment": "👁️", "Discipleship": "👨‍🏫", "Divinity": "☀️",
  "Endurance": "💯", "Eternity": "♾️", "Exaltation": "🌟", "Faith": "📖",
  "Fate": "⚓", "Favor": "🌙", "Fellowship": "👥", "Forgiveness": "🕯️",
  "Fulfillment": "🏅", "Glorification": "👑", "Glory": "🥇", "Grace": "✨",
  "Guardianship": "🔒", "Healing": "🌿", "Holiness": "🕌", "Hope": "🌅",
  "Hospitality": "🚪", "Humility": "🙇", "Immortality": "👻", "Integrity": "📏",
  "Intercession": "📣", "Joy": "😊", "Justification": "✔️", "Light": "🌠",
  "Longsuffering": "⏳", "Love": "❤️", "Loyalty": "💎", "Meditation": "🧘",
  "Meekness": "🦢", "Mercy": "💝", "Nurture": "🌼", "Obedience": "✋",
  "Peace": "🕊️", "Perseverance": "🏃", "Petition": "📝", "Piety": "🏛️",
  "Praise": "🙌", "Prayer": "🙏", "Predestination": "🗺️", "Prosperity": "💰",
  "Protection": "🛡️", "Providence": "🎰", "Provision": "🍞", "Purity": "🤍",
  "Reconciliation": "🔗", "Redemption": "🔓", "Refuge": "🏰", "Renewal": "🌱",
  "Repentance": "😔", "Restoration": "🔧", "Resurrection": "🔄", "Reverence": "🎭",
  "Righteousness": "⭐", "Sacredness": "⛩️", "Sacrifice": "💀", "Salvation": "✝️",
  "Sanctification": "🔮", "Sanctity": "🔔", "Sanctuary": "⛪", "Self-Control": "🎲",
  "Serenity": "🌊", "Shepherding": "🐑", "Sovereignty": "🦅", "Spirituality": "🌌",
  "Steadfastness": "🪨", "Stewardship": "🏠", "Strength": "💪", "Submission": "🙇‍♀️",
  "Supplication": "🥺", "Surrender": "🏳️", "Sustenance": "🍽️", "Testimony": "📢",
  "Thanksgiving": "🎉", "Transfiguration": "🌈", "Transformation": "🦋", "Trust": "🤝",
  "Truth": "🔦", "Unity": "👐", "Victory": "🥇", "Virtue": "👼",
  "Wisdom": "🦉", "Witness": "👀", "Worship": "🎵", "Counsel": "💬",
  "Faithfulness": "✅", "Fortitude": "🦁", "Gentleness": "🌸", "Goodness": "😇",
  "Justice": "⚖️", "Kindness": "🤗", "Knowledge": "📚", "Patience": "⏰",
  "Prudence": "🧠", "Temperance": "🎯", "Understanding": "💡",
  "Angry": "😠", "Fearful": "😨", "Triumphant": "🏆", "Serious": "😐",
  "Joyful": "😊", "Anxious": "😰", "Sad": "😢", "Warm": "🤗",
  "Relieved": "😌", "Amazed": "😲", "Celebratory": "🎉", "Frustrated": "😤",
  "Pleading": "🥺", "Solemn": "😔", "Hopeful": "🌅", "Disappointed": "😞",
  "Worried": "😟", "Determined": "💪", "Furious": "🤬", "Tender": "💕",
  "Delighted": "😄", "Shocked": "😱", "Stern": "😠", "Skeptical": "🤨",
  "Nervous": "😬", "Excited": "🤩", "Inquisitive": "🤔", "Happy": "😊",
  "Caring": "🤗", "Deceitful": "🤥", "Encouraging": "👍", "Reverent": "🙏",
  "Confident": "😎", "Pleasant": "😊", "Affectionate": "🥰", "Somber": "😔",
  "Authoritative": "👮", "Reassuring": "🤝", "Cheerful": "😄", "Deadly": "💀",
  "Earnest": "😤", "Peaceful": "🕊️", "Disgusted": "🤢", "Confused": "😕",
  "Loving": "💕", "Crying": "😭", "Instructive": "👨‍🏫", "Adoring": "😍",
  "Ominous": "⚡", "Dismissive": "🙄", "Surprised": "😮", "Disapproving": "👎",
  "Annoyed": "😒", "Commanding": "👉", "Astonished": "😲", "Devilish": "😈",
  "Smug": "😏", "Exhausted": "😫", "Cautionary": "⚠️", "Grateful": "🙏",
  "Calm": "😌", "Mischievous": "😏", "Embarrassed": "😳", "Defiant": "✊",
  "Grim": "☠️", "Urgent": "🔴", "Focused": "👁️", "Humble": "😌",
  "Resolute": "👊", "Resigned": "😔", "Generous": "🎁", "Desperate": "😩",
  "Mysterious": "🎭", "Admiring": "🤩", "Contemptuous": "🙄", "Tired": "😴",
  "Emphatic": "💯", "Proud": "🦁", "Threatening": "⚔️", "Playful": "🎮",
  "Firm": "💪", "Greedy": "🤑", "Hostile": "😠", "Neutral": "😐",
  "Creation": "🌍", "Gospel": "📰", "Prophecy": "🗣️", "Kingdom": "🏰",
  "Persecution": "⛓️", "Parable": "🎨", "Sacrament": "🍷", "Tithes": "🪙",
  "Disciple": "👣", "Sin": "❌", "Temptation": "🍎",
};

search.addWidgets([
  configure({
    hitsPerPage: 20,
    query: "",
  }),

  stats({
    container: "#stats",
    templates: {
      text: ({ nbHits, hasNoResults, hasOneResult, processingTimeMS }) => {
        if (hasNoResults) return "No results";
        if (hasOneResult) return `1 result in ${processingTimeMS}ms`;
        return `✨ ${nbHits.toLocaleString()} results in ${processingTimeMS}ms`;
      },
    },
  }),

  infiniteHits({
    container: "#hits",
    cssClasses: {
      list: "list-unstyled",
      item: "d-flex flex-column p-3 resultscolor",
      loadMore: "btn btn-primary mx-auto d-block mt-4",
    },
    templates: {
      item: (hit, { html, components }) => html`
        <div class="mb-0">
          <a href="https://www.kingjamesbibleonline.org/${hit.bname.replace(/ /g, '-')}-${hit.cnum}-${hit.vnum}/" target="_blank">
            <b class='dred'>${hit.bname} ${hit.cnum}:${hit.vnum}</b>
          </a><br />
          <span style="color:black;font-size:1.1rem;">${components.Highlight({ hit, attribute: "vtext" })}</span>
        </div>
      `,
      empty: (state, { html }) =>
        html`No results found. Try selecting a different emotion.`,
    },
  }),

  refinementList({
    container: "#emojis-refinement-list",
    attribute: "emojis",
    searchable: true,
    searchablePlaceholder: "Search emotions...",
    showMore: true,
    showMoreLimit: 200,
    limit: 30,
    sortBy: ["name:asc"],
    cssClasses: {
      searchableInput: "form-control form-control-sm mb-2 border-light-2",
      searchableSubmit: "d-none",
      searchableReset: "d-none",
      showMore: "btn btn-secondary btn-sm align-content-center",
      list: "list-unstyled",
      count: "badge bg-light text-bg-light ms-2",
      label: "d-flex align-items-center text-capitalize mb-2",
      checkbox: "me-2",
    },
  }),

  currentRefinements({
    container: "#current-refinements",
    cssClasses: {
      list: "list-unstyled",
      label: "d-none",
      item: "h5",
      category: "badge bg-light text-bg-light px-3 m-2",
      categoryLabel: "text-capitalize",
      delete: "btn btn-sm btn-link p-0 ps-2",
    },
    transformItems: (items) => items.map(item => ({ ...item, label: "" })),
  }),
]);

search.start();

$(function() {
  search.helper.setQuery("").search();
});
